import React from 'react'
import Grid from '@mui/material/Grid';
import makuniImage from '../images/makuniImage.jpg';
import makuniImage2 from '../images/makuniImage2.jpg';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

function HotelBooking() {
    return (
        <Grid container spacing={2} alignItems="center"
        justifyContent="center">
        <Grid item xs={8} style={{marginTop:20}}>
        <h2>
        Work in progress, stay tuned for updates!
      </h2>
     
       
        </Grid>

        </Grid>
    )
}

export default HotelBooking